import { render, staticRenderFns } from "./Hospitals.vue?vue&type=template&id=4689e533&"
import script from "./Hospitals.vue?vue&type=script&lang=js&"
export * from "./Hospitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4689e533')) {
      api.createRecord('4689e533', component.options)
    } else {
      api.reload('4689e533', component.options)
    }
    module.hot.accept("./Hospitals.vue?vue&type=template&id=4689e533&", function () {
      api.rerender('4689e533', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Filters/Headers/Hospitals.vue"
export default component.exports